 import React ,{useEffect,useState} from 'react'
import { GetClinicData } from './API';
import ClinicItem from './ClinicItem';
export default function ClinicList(props) {
    const [data, setData] = useState([]);
    useEffect(() => {
        GetClinicData(props.camp).then(data => {
        console.log(data);
        setData(data.queues);
      });
    }, [props.camp]);
    return (
        <div class="row" id="clinics"> 
          {data.map( (item,index) => <ClinicItem key={item.q_id} {...item}/> )}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/Clinic/ClinicList.js